export default __webpack_public_path__ + "static/media/phone.1fb689f0.svg";